import { Box, Tab, Tabs } from '@mui/material';
import React, { FC } from 'react';

interface SelectCategoryProps {
  onGroupClick: (group: number) => void;
  group: number;
}

export const SelectCategory: FC<SelectCategoryProps> = ({ group, onGroupClick }) => {
  const [value, setValue] = React.useState(group);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onGroupClick(newValue);
    setValue(newValue);
  };

  return (
    <Box sx={{ maxWidth: { xs: 320, sm: 480, md: 760 } }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="Уровень сложности"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        <Tab value={0} label="Уровень 1" />
        <Tab value={1} label="Уровень 2" />
        <Tab value={2} label="Уровень 3" />
        <Tab value={3} label="Уровень 4" />
        <Tab value={4} label="Уровень 5" />
        <Tab value={5} label="Уровень 6" />
      </Tabs>
    </Box>
  );
};
